import React, { useState, useEffect } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { TableLoader } from "../../../../Common/ShimmerLoader";
//import { innergetAllZoneWiseReport } from "../../../Apis/satReportsApi";
import {
    GHMCTripsReport
} from "../../../../Apis/ttrReportsApi";
import CustomDataTable from "../../../../Common/ReportTable/ReportTable";
import * as XLSX from "xlsx";

import ExcelJS from "exceljs";

const HireTonnageReport = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [getZoneInnerReport, setgetZoneInnerReport] = useState([]);
  const [data, setData] = useState(null);
  const location = useLocation()

  useEffect(() => {
    if (location.state) {
      setData(location.state); // Set data when it's available
    } else {
      fetchData(); // Fetch data when component mounts if state is not available
    }
  }, [location.state]);

  const fetchData = async (ZoneId, VehicleTypeId) => {
    try {
      setIsLoading(true);
      // Perform the API call again to fetch data
      const requestData = { Date, VehicleTypeId, ZoneId }; // Assuming these are defined somewhere
      const response = await GHMCTripsReport(requestData);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching zone wise report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // const data = location.state
  const [zonesData, setZonesData] = useState([]);


  const zoneReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["slno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
    {
      name: "TS Name",
      selector: (row) =>row["transferStationName"],
      cell: (row) => (  
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["transferStationName"]}
        </span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Zone",
      selector: (row) =>row["zoneName"],
      cell: (row) => (  
        <span
        // style={{ color: "blue", cursor: "pointer" }}
         //  onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["zoneName"]}
        </span>
      ),
      sortable: true,
      width: "150px",
    },
    
    {
      name: <>Transporter</>,
      selector: (row) =>row["transporter"],
      cell: (row) => (
        <span
        // style={{ color: "blue" }}
        > {row["transporter"]}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle Number</>,
      selector: (row) =>row["vehicleNumber"],
      cell: (row) => (
        <span
        //style={{ color: "blue" }}
        >{row["vehicleNumber"]}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle Type</>,
      selector: (row) =>row["vehicleType"],
      cell: (row) => (
        <span
        //style={{ color: "blue" }}
        >{row["vehicleType"]}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle Capacity</>,
      selector: (row) =>row["vehicleCapacity"],
      cell: (row) => (
        <span
        //  style={{ color: "blue" }}
        >{row["vehicleCapacity"]}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <>Date Time IN</>,
      selector: (row) =>row["dateTimeIn"],
      cell: (row) => (
        <span
        //style={{ color: "blue" }}
        >{row["dateTimeIn"]}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <>Date Time Out</>,
      selector: (row) =>row["dateTimeOut"],
      cell: (row) => (
        <span
        // style={{ color: "blue" }}
        >{row["dateTimeOut"]}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <>Turn Around Time</>,
      selector: (row) =>row["turnAroundTime"],
      cell: (row) => (
        <span
        //style={{ color: "blue" }}
        >{row["turnAroundTime"]}</span>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Tonnage",
      selector: (row) =>row["tonnage"],
      cell: (row) => (
        <span
        //style={{ color: "blue" }}
        >{row["tonnage"]}</span>
      ),
      sortable: true,
      width: "120px",
    },
  ];

  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;  

  
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `HIRE Tonnage Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Trips&Tonnage");
  
    // Define styles
   const boldFont = { bold: true };
  
  // Add the downloadDateTime to the correct row and columns, and ensure formatting
  worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
  worksheet.mergeCells(1, 2, 1, 4); // Merge cells for downloadDateTime from column 2 to 4
  worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
  worksheet.getCell(1, 2).font = boldFont; // Set font style
  worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content
  
  // Apply styles to the merged cells (B1, C1, D1)
  for (let col = 2; col <= 4; col++) {
    worksheet.getCell(1, col).font = boldFont; // Set styles individually
    worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
  }
  
  // Add "Zone Details" to the correct row and columns, and ensure formatting
  worksheet.addRow(["", "", "HIRE Tonnage Details", ""]); // Update array length to match new cell range
  worksheet.mergeCells(2, 2, 2, 4); // Merge cells for Zone Details from column 2 to 4
  worksheet.getCell(2, 2).value = "HIRE Tonnage Details"; // Ensure the value is set after merging
  worksheet.getCell(2, 2).font = boldFont; // Set font style
  worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content
  
  // Apply styles to the merged cells (B2, C2, D2)
  for (let col = 2; col <= 4; col++) {
    worksheet.getCell(2, col).font = boldFont; // Set styles individually
    worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
  }
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "TS Name",
      "Zone",
      "Transporter",
      "Vehicle Number",
      "Vehicle Type",
      "Vehicle Capacity",
      "Date Time IN",
      "Date Time Out",
      "Turn Around Time",
      "Tonnage",
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left",color:"#fff" }; // Center align the cell content
      if (colNumber >= 1 && colNumber <= 13) {
        // Apply background color and set text color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" } // White text color
        };
      }
    });
  
    // Add data rows
    data.forEach((item, index) => {
    
      worksheet
        .addRow([
          index + 1,
          item.transferStationName?? "N/A",
          item. zoneName?? "N/A",
          item.transporter?? "N/A",
          item.vehicleNumber?? "N/A",
          item.vehicleType?? "N/A",
          item.vehicleCapacity?? "N/A",
          item.dateTimeIn?? "N/A",
          item.dateTimeOut?? "N/A",
          item.turnAroundTime?? "N/A",
          item.tonnage?? "N/A",
       
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 13) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });
  
    // Add total row with bold font
  
  
    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
    ];
  
    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "HIRE Tonnage.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="top-header page-title">
              <span>{" "}
                    HIRE TTR Report</span>
            </div>
            <div className="page-header"></div>
            <div class="row" style={{ textAlign: "justify" }}>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-end mt-3 mb-3">
                  <button className="btn btn-secondary  me-2" style={{}}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                  <button className="btn btn-excel" 
                    onClick={downloadAsExcel}
                  >
                    <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                  </button>

                </div>

                {data &&
                  <CustomDataTable
                    data={data}
                    columns={zoneReportColumns}
                  // headers={headers}
                  // link={true}
                  // search={true}
                  // fromDate={fromDate}
                  // toDate={toDate}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HireTonnageReport;
